'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function LoanApplication(presenter, applicationModel) {
  this.presenter = presenter;
  this.id = applicationModel.id;
  this._dateFormat = 'YYYY-MM-DD';

  this._LOAN_APPS_MODEL = 'money.applications.loan_applications';
  this._LOAN_APPS_TEMP_INCOME_MODEL = 'money._loanApplicationIncome';

  this._applicationsArrayIndex = null;
  this._callbackRefs = {};

  this._getApplicationArrayIndex = function () {
    if (this._applicationsArrayIndex === null || this.presenter.getModelProperty('money.applications.loan_applications[' + this._applicationsArrayIndex + '].id') !== this.id) {
      var applications = this.presenter.getModelProperty('money.applications.loan_applications');
      for (var i = 0; i < applications.length; i++) {
        if (applications[i].id === this.id) {
          this._applicationsArrayIndex = i;
          break;
        }
      }
    }
    return this._applicationsArrayIndex;
  };

  this.getModelPath = function () {
    return this._LOAN_APPS_MODEL + '[' + this._getApplicationArrayIndex() + ']';
  };

  /*
    Creates an employment resource for the loan application
       formElement
        The < form > that contains the employment fields:
          name[required]
          phone_number[required]
          extension[optional]
          job_title[required]
       callbacks
        Object containing the callbacks with the following keys
          success
          failure
       Returns:
        teardownFn[Function]
  */
  this.createEmployment = function (formElement, callbacks) {
    var index = this._getApplicationArrayIndex();
    var createEmploymentAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.create_loan_application_employment';

    if (formElement.tagName && formElement.tagName.toLowerCase() !== 'form' || formElement.mogo().declaredClass) {
      if (callbacks.failure) {
        callbacks.failure({
          errors: [{
            code: 400,
            key: 'formElement type error'
          }]
        }, 400);
      }
      return;
    }
    if (this.presenter.hasAction(createEmploymentAction)) {
      this.presenter.addActionToNode(formElement, createEmploymentAction);
      // Setup callback
      var callbackId = this.presenter.addCallbackToAction(createEmploymentAction, this._onCreateEmployment.bind(this, callbacks, formElement));
      // ScanDom because action dynamically added to form
      this.presenter.scanDOM(formElement.parentElement);

      return this._createTeardownFunction(createEmploymentAction, callbackId);
    }
    if (callbacks.failure) {
      callbacks.failure({
        errors: [{
          code: 404,
          key: 'no_action_error',
          msg: 'cannot find create_loan_application'
        }]
      }, 404);
    }
  };

  this._onCreateEmployment = function (callbacks, formElement, data, response, request) {
    var index = this._getApplicationArrayIndex();
    // Set disable state for the submit button
    this._setDisableLoadState(formElement);
    if (response === 200) {
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (data, response, callbacks) {
        if (callbacks.success) {
          // Disable the submit button
          this._removeDisableLoadState(formElement);
          callbacks.success(data, response);
        }
      }.bind(this, data, response, callbacks));
    } else if (callbacks.failure) {
      // Disable the submit button
      this._removeDisableLoadState(formElement);
      callbacks.failure(data, response, request);
    }
  };

  /*
    Updates an employment resource for the loan application
       formElement
        The <form> that contains the employment fields:
          name [required]
          phone_number [required]
          extension [optional]
          job_title [required]
          
      callbacks
        Object containing the callbacks with the following keys
          success
          failure
       Returns:
        teardownFn [Function]
  */
  this.updateEmployment = function (formElement, callbacks) {
    var index = this._getApplicationArrayIndex();
    var updateEmploymentAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.update_loan_application_employment';
    var extensionPropertyPath = this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.extension';

    // Non valid form element
    if (formElement.tagName && formElement.tagName.toLowerCase() !== 'form' || formElement.mogo().declaredClass) {
      if (callbacks.failure) {
        callbacks.failure({
          errors: [{
            code: 400,
            key: 'formElement type error'
          }]
        }, 400);
      }
      return;
    }
    if (this.presenter.hasAction(updateEmploymentAction)) {
      // Insert data-action
      this.presenter.addActionToNode(formElement, updateEmploymentAction);

      // Setup callback
      var callbackId = this.presenter.addCallbackToAction(updateEmploymentAction, this._onUpdateEmployment.bind(this, callbacks, formElement));

      // Send empty string if extension is empty
      this.presenter.extendViewMap(_defineProperty({}, extensionPropertyPath, {
        set: function set(value) {
          if (!value) {
            return '';
          }
          return value;
        }
      }));

      // ScanDom because action dynamically added to form
      this.presenter.scanDOM(formElement.parentElement);

      return this._createTeardownFunction(updateEmploymentAction, callbackId);
    }
    if (callbacks.failure) {
      callbacks.failure({
        errors: [{
          code: 404,
          key: 'no_action_error',
          msg: 'update_loan_application_employment'
        }]
      }, 404);
    }
  };

  this._onUpdateEmployment = function (callbacks, formElement, data, response, request) {
    var index = this._getApplicationArrayIndex();
    // Set disable state for the submit button
    this._setDisableLoadState(formElement);

    if (response === 200) {
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (data, response, callbacks) {
        if (callbacks.success) {
          // Disable the submit button
          this._removeDisableLoadState(formElement);
          callbacks.success(data, response);
        }
      }.bind(this, data, response, callbacks));
    } else if (callbacks.failure) {
      // Disable the submit button
      this._removeDisableLoadState(formElement);
      callbacks.failure(data, response, request);
    }
  };

  /*
    Saves loan application pay_frequency
      data
        pay_frequency value
  */
  this.savePayFrequency = function (data) {
    var currentPayFrequency = this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.pay_frequency');
    if (data !== currentPayFrequency) {
      this.presenter.setModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.pay_frequency', data);
      this.presenter.removeModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.first_pay_date');
      this.presenter.removeModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.second_pay_date');
      this.presenter.removeModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.last_day_of_month');
    }
  };

  /*
      Saves Semi-Monthly Pay Frequency values
         lastOfDay [Boolean]
            last_day_of_month property value
          firstDate [Required]
            integer that will be converted to first_pay_date property value (BE only cares about the date)
       
       Conditions: pay frequency: monthly | last day of month: true | first pay date: null | second pay date: null
                   pay frequency: monthly | last day of month: false | first pay date: 2019-01-07 | second pay date: null
   */
  this.saveMonthlyPayFrequency = function (lastDayOfMonthBoolean, firstDate) {
    var firstPayDate = void 0;
    var payDate = firstDate;
    var lastOfDay = lastDayOfMonthBoolean === 'true';
    // Date
    var year = moment().format('YYYY');
    var date = moment().format(payDate);

    if (lastOfDay === true) {
      firstPayDate = null;
    } else {
      // month = 0 to avoid leap year and Feburary;
      firstPayDate = moment([year, 0, date]).format(this._dateFormat);
    }
    this.presenter.setModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.first_pay_date', firstPayDate);
    this.presenter.setModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.last_day_of_month', lastOfDay);
  };

  /*
     Saves Weekly Pay Frequency values
        lastOfDay [Boolean]
          last_day_of_month property value
         weeklyDate [Required]
          string first_pay_date property value
       Conditions: pay frequency: weekly | last day of month: null | first pay date: 2019-01-07 | second pay date: null
   */
  this.saveWeeklyPayFrequency = function (weeklyDate) {
    var firstPayDate = void 0;
    var payDate = weeklyDate; // integer value , ie monday is 0
    if (payDate) {
      // month - 1 because starts at 0;
      firstPayDate = moment(payDate).format(this._dateFormat);
    }
    this.presenter.setModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.first_pay_date', firstPayDate);
    this.presenter.setModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.last_day_of_month', false);
  };

  /*
     Saves Semi-Monthly Pay Frequency values
        lastOfDay [Boolean]
          last_day_of_month property value
         firstDate [Required]
          integer that will be converted to first_pay_date property value (BE only cares about the date)
      
        secondDate [Required]
         integer that will be converted to second_pay_date property value (BE only cares about the date)
       Conditions: pay frequency: semi-monthly | last day of month: true | first pay date: 2019-01-07 | second pay date: null
                  pay frequency: semi-monthly | last day of month: false | first pay date: 2019-01-07 | second pay date: 2019-01-21
  */
  this.saveSemiMonthlyPayFrequency = function (lastDayOfMonthBoolean, firstDate, secondDate) {
    var firstPayDate = void 0;
    var secondPayDate = void 0; // integer value , ie monday is 0
    var lastOfDay = lastDayOfMonthBoolean === 'true';
    var year = moment().format('YYYY');
    // month = 0 to avoid leap year and Feburary;
    if (lastOfDay === true) {
      // Only firstPayDate should be submitted
      firstPayDate = moment([year, 0, moment().format(firstDate)]).format(this._dateFormat);
      secondPayDate = null;
    } else {
      firstPayDate = moment([year, 0, moment().format(firstDate)]).format(this._dateFormat);
      secondPayDate = moment([year, 0, moment().format(secondDate)]).format(this._dateFormat);
    }
    this.presenter.setModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.first_pay_date', firstPayDate);
    this.presenter.setModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.second_pay_date', secondPayDate);
    this.presenter.setModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.last_day_of_month', lastOfDay);
  };

  /*
     Saves Bi-Weekly Pay Frequency values
        lastOfDay [Boolean]
          last_day_of_month property value
        
        datweeklyDate [Required]
          first_pay_date property value
       Conditions: pay frequency: biweekly | last day of month: null | first pay date: 2019 - 01 - 07 | second pay date: null
  */
  this.saveBiWeeklyPayFrequency = function (weeklyDate) {
    var firstPayDate = void 0;
    var payDate = weeklyDate; // integer value , ie monday is 0
    if (payDate) {
      // month - 1 because starts at 0;
      firstPayDate = moment(payDate).format(this._dateFormat);
    }
    this.presenter.setModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.first_pay_date', firstPayDate);
    this.presenter.setModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.last_day_of_month', false);
  };

  /*
    Updates income properties using data action employment.update_loan_application_employment
       callbacks [Optional]
        Object containing the callbacks with the following keys
          success
          failure
  */
  this.submitIncome = function (callbacks) {
    var index = this._getApplicationArrayIndex();
    var submitIncomeAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.update_loan_application_employment';

    // Validate if there's a model
    if (this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL)) {
      // need to add payload so no other fluff in submit
      var incomeModel = {};
      incomeModel.pay_frequency = this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.pay_frequency');
      incomeModel.first_pay_date = this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.first_pay_date');
      incomeModel.second_pay_date = this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.second_pay_date');
      incomeModel.last_day_of_month = this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.last_day_of_month');

      for (var key in incomeModel) {
        if (!incomeModel[key]) delete incomeModel[key];
      }
    } else {
      if (callbacks.failure) {
        callbacks.failure({
          errors: [{
            code: 404,
            key: 'no loan application income model found, please try again'
          }]
        }, 404);
      }
      return;
    }

    // Submit action is the same action has update loan application employment,
    // which is why callbackRefs.update_loan_application_employment
    if (this.presenter.hasAction(submitIncomeAction)) {
      if (this._callbackRefs.update_loan_application_employment) {
        this.presenter.removeCallbackFromAction(submitIncomeAction, this._callbackRefs.update_loan_application_employment);
      }
      this.presenter.performAction(submitIncomeAction, incomeModel, // Massaged data from earlier
      this._onUpdateIncome.bind(this, callbacks));
    } else if (callbacks.failure) {
      callbacks.failure({
        errors: [{
          code: 404,
          key: 'no_action_error'
        }]
      }, 404);
    }
  };

  this._onUpdateIncome = function (callbacks, data, response, request) {
    if (response === 200) {
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + this._getApplicationArrayIndex() + ']', null, function (callbacks, data, response) {
        if (callbacks.success) {
          callbacks.success(data, response);
        }
      }.bind(this, callbacks, data, response));
    } else if (callbacks.failure) {
      callbacks.failure(data, response, request);
    }
  };

  this.setTempIncomeModel = function () {
    var index = this._getApplicationArrayIndex();

    if (this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment')) {
      var submittedModel = {
        pay_frequency: this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.pay_frequency'),
        first_pay_date: this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.first_pay_date'),
        second_pay_date: this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.second_pay_date'),
        last_day_of_month: this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.last_day_of_month')
      };

      if (!this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL)) {
        this.presenter.createModel(this._LOAN_APPS_TEMP_INCOME_MODEL, {
          data: submittedModel
        });
      }
    } else if (!this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL)) {
      this.presenter.createModel(this._LOAN_APPS_TEMP_INCOME_MODEL, {
        data: {}
      });
    }
  };

  // Resets Temp Income model, for when users closes the app
  this.resetIncome = function () {
    var index = this._getApplicationArrayIndex();

    if (this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment')) {
      var submittedModel = {
        pay_frequency: this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.pay_frequency'),
        first_pay_date: this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.first_pay_date'),
        second_pay_date: this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.second_pay_date'),
        last_day_of_month: this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.last_day_of_month')
      };

      this.presenter.createModel(this._LOAN_APPS_TEMP_INCOME_MODEL, {
        data: submittedModel
      });
    } else {
      this.presenter.createModel(this._LOAN_APPS_TEMP_INCOME_MODEL, {
        data: {}
      });
    }
  };

  // Resets Application model, for when users cancel/cancel the app
  this.resetData = function () {
    var model = this.getModelPath();
    if (this.presenter.getModelProperty(model)) {
      this.presenter.resetModels(model);
    }
  };

  /*
    Updates an employment resource for the loan application
       form data
        The <form> that contains the employment fields:
          amount [required]
          is_protected [required]
          
      callbacks
        Object containing the callbacks with the following keys
          success
          failure
  */
  this.updateLoanApplication = function (formData, callbacks) {
    var index = this._getApplicationArrayIndex();
    var updateAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.update_loan_application';

    if (!formData) {
      if (callbacks.failure) {
        callbacks.failure({
          errors: [{
            code: 404,
            msg: 'No loan application data submitted'
          }]
        }, 404);
      }
      return;
    }

    if (this.presenter.hasAction(updateAction)) {
      // there shouldn't be any callback for this action, only used for this screen.
      this.presenter.performAction(updateAction, formData, this._onUpdateLoanApplication.bind(this, callbacks));
    } else if (callbacks.failure) {
      callbacks.failure({
        errors: [{
          code: 400,
          msg: 'No update loan application action found'
        }]
      }, 400);
    }
  };

  this._onUpdateLoanApplication = function (callbacks, data, response, request) {
    var index = this._getApplicationArrayIndex();
    if (response === 200) {
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (callbacks, data, response) {
        if (callbacks.success) {
          callbacks.success(data, response);
        }
      }.bind(this, callbacks, data, response));
    } else if (callbacks.failure) {
      callbacks.failure(data, response, request);
    }
  };

  /*
    Creates an bank account resource for the loan application
       formElement
        The < form > that contains the bank fields:
          bank_id [required]
  
      callbacks
        Object containing the callbacks with the following keys
          success
          failure
       Returns:
        teardownFn[Function]
  */
  this.addBank = function (formElement, callbacks) {
    var index = this._getApplicationArrayIndex();
    var createBankAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.create_loan_application_bank_account';
    var bankIdPropertyPath = this._LOAN_APPS_MODEL + '[' + index + ']' + '.bank_account.bank_id';

    if (formElement.tagName && formElement.tagName.toLowerCase() !== 'form' || formElement.mogo().declaredClass) {
      if (callbacks.failure) {
        callbacks.failure({
          errors: [{
            code: 400,
            key: 'formElement type error'
          }]
        }, 400);
      }
      return;
    }

    if (this.presenter.hasAction(createBankAction)) {
      // add the action to the form
      this.presenter.addActionToNode(formElement, createBankAction);

      // Convert string to Integer
      this.presenter.extendViewMap(_defineProperty({}, bankIdPropertyPath, {
        set: function set(value) {
          return parseInt(value);
        }
      }));
      // ScanDom because actions are dynamically added
      this.presenter.scanDOM(formElement.parentElement);
      // Setup Callback to Action
      var callbackId = this.presenter.addCallbackToAction(createBankAction, this._onAddBank.bind(this, callbacks, formElement));

      return this._createTeardownFunction(createBankAction, callbackId);
    }
    if (callbacks.failure) {
      callbacks.failure({
        errors: [{
          code: 404,
          msg: 'no_action_error'
        }]
      }, 404);
    }
  };

  this._onAddBank = function (callbacks, formElement, data, response, request) {
    var index = this._getApplicationArrayIndex();
    // Set the disable state for the submit button
    this._setDisableLoadState(formElement);
    if (response === 200) {
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (data, response, callbacks) {
        if (callbacks.success) {
          // Disable the submit button
          this._removeDisableLoadState(formElement);
          callbacks.success(data, response);
        }
      }.bind(this, data, response, callbacks));
    } else if (callbacks.failure) {
      // Disable the submit button
      this._removeDisableLoadState(formElement);
      callbacks.failure(data, response, request);
    }
  };

  /*
    Updates an bank account resource for the loan application
       formElement
        The < form > that contains the bank fields:
          bank_id [required]
  
      callbacks
        Object containing the callbacks with the following keys
          success
          failure
  */
  this.updateBank = function (formElement, callbacks) {
    var index = this._getApplicationArrayIndex();
    var updateBankAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.bank_account.update_loan_application_bank_account';
    var bankIdPropertyPath = this._LOAN_APPS_MODEL + '[' + index + ']' + '.bank_account.bank_id';

    if (formElement.tagName && formElement.tagName.toLowerCase() !== 'form' || formElement.mogo().declaredClass) {
      if (callbacks.failure) {
        callbacks.failure({
          errors: [{
            code: 400,
            key: 'formElement type error'
          }]
        }, 400);
      }
      return;
    }

    if (this.presenter.hasAction(updateBankAction)) {
      // Insert data-action
      this.presenter.addActionToNode(formElement, updateBankAction);
      // Convert string to Integer
      this.presenter.extendViewMap(_defineProperty({}, bankIdPropertyPath, {
        set: function set(value) {
          return parseInt(value);
        }
      }));
      // ScanDom because actions are dynamically added
      this.presenter.scanDOM(formElement.parentElement);
      // Setup Callback
      var callbackId = this.presenter.addCallbackToAction(updateBankAction, this._onUpdateBank.bind(this, callbacks, formElement));

      return this._createTeardownFunction(updateBankAction, callbackId);
    }
    if (callbacks.failure) {
      callbacks.failure({
        errors: [{
          code: 404,
          msg: 'no_action_error'
        }]
      }, 404);
    }
  };

  this._onUpdateBank = function (callbacks, formElement, data, response, request) {
    var index = this._getApplicationArrayIndex();
    // Set the disable state for the submit button
    this._setDisableLoadState(formElement);
    if (response === 200) {
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (data, response, callbacks) {
        if (callbacks.success) {
          // Disable the submit button
          this._removeDisableLoadState(formElement);
          callbacks.success(data, response);
        }
      }.bind(this, data, response, callbacks));
    } else if (callbacks.failure) {
      // Disable the submit button
      this._removeDisableLoadState(formElement);
      callbacks.failure(data, response, request);
    }
  };

  /*
    Updates the Loan Application Bank resource abs_status property
       data
        abs_status: [required]
          link_failure | opt_out | not_supported
       callbacks
        Object containing the callbacks with the following keys
          success
          failure
  */

  this.updateBankStatus = function (data, callbacks) {
    var index = this._getApplicationArrayIndex();
    var updateBankAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.bank_account.update_loan_application_bank_account';

    if (this.presenter.hasAction(updateBankAction)) {
      this.presenter.performAction(updateBankAction, data, this._updateBankStatus.bind(this, callbacks));
    } else if (callbacks.failure) {
      callbacks.failure({
        errors: [{
          code: 404,
          msg: 'no_action_error'
        }]
      }, 404);
    }
  };

  this._updateBankStatus = function (callbacks, data, response, request) {
    var index = this._getApplicationArrayIndex();

    if (response === 200) {
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (data, response, callbacks) {
        if (callbacks.success) {
          callbacks.success(data, response);
        }
      }.bind(this, data, response, callbacks));
    } else if (callbacks.failure) {
      callbacks.failure(data, response, request);
    }
  };

  /*
    Submits Loan Application
       formElement
        hard_credit_check_consent: Boolean
        first_payment_date: [date format][string]
        payment_frequency: biweekly or monthly
  
      callbacks
        Object containing the callbacks with the following keys
          success
          failure
      
      formElement [optional]
        trigger form element states
  */
  this.updateLoanApplicationStatus = function (formData, callbacks, formElement) {
    var index = this._getApplicationArrayIndex();
    var updateLoanAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.update_loan_application';

    if (!formData) {
      if (callbacks.failure) {
        callbacks.failure({
          errors: [{
            code: 404,
            msg: 'No loan application data submitted'
          }]
        }, 404);
      }
      return;
    }

    if (this.presenter.hasAction(updateLoanAction)) {
      this.presenter.performAction(updateLoanAction, formData, this._onUpdateLoanApplicationStatus.bind(this, callbacks, formElement));
    } else if (callbacks.failure) {
      callbacks.failure({
        errors: [{
          code: 400,
          msg: 'No action found'
        }]
      }, 400);
    }
  };

  this._onUpdateLoanApplicationStatus = function (callbacks, formElement, data, response, request) {
    var index = this._getApplicationArrayIndex();
    // Set the disable state for the submit button
    this._setDisableLoadState(formElement);
    if (response === 200) {
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (callbacks, data, response) {
        if (callbacks.success) {
          // Disable the submit button
          this._removeDisableLoadState(formElement);
          callbacks.success(data, response);
        }
      }.bind(this, callbacks, data, response));
    } else if (callbacks.failure) {
      // Disable the submit button
      this._removeDisableLoadState(formElement);
      callbacks.failure(data, response, request);
    }
  };

  /*
    Verify bank account with the associated loan application
    Poll bank_verification_result for ABV result status.
    As of end of May 2019, ABV has not been integrated yet. Which means,
    FE should look for completion status because results will always fail.
  */
  this.verifyBankAccount = function (callbacks) {
    var index = this._getApplicationArrayIndex();
    var verifyBankAccountAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.bank_verification';

    if (this.presenter.hasAction(verifyBankAccountAction)) {
      this.presenter.performAction(verifyBankAccountAction, null, this._onVerifyBankAccount.bind(this, callbacks), 6000);
    } else if (callbacks.failure) {
      callbacks.failure({
        errors: [{
          code: 404,
          msg: 'No verify bank account action found'
        }]
      }, 404);
    }
  };

  this._onVerifyBankAccount = function (callbacks, data, response, request) {
    var index = this._getApplicationArrayIndex();
    var bankResultAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.bank_verification_result';

    if (response === 200) {
      // Update LApp to see bankResultAction rellink
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (callbacks) {
        if (this.presenter.hasAction(bankResultAction)) {
          // Remove existing action callback
          if (this.bankResultCallbackId) {
            this.presenter.removeCallbackFromAction(bankResultAction, this._onPollBankResultCallback.bind(this));
          }

          this.bankResultCallbackId = this.presenter.addCallbackToAction(bankResultAction, this._onPollBankResultCallback.bind(this, callbacks));

          // Start Poll Action, add callback to action and check conditions in there
          // recall addCallback to action will have data, result
          this._timer = new Date();
          this.presenter.startPollAction(bankResultAction);
        }
      }.bind(this, callbacks));
    } else {
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (callbacks) {
        if (callbacks.failure) {
          callbacks.failure(data, response);
        }
      }.bind(this, callbacks, data, response));
    }
  };

  this._onPollBankResultCallback = function (callbacks, data, response) {
    var index = this._getApplicationArrayIndex();
    var bankResultAction = this._LOAN_APPS_MODEL + '[' + index + ']' + '.bank_verification_result';

    // Poll for Completed status, this means ABS is done,
    if (response === 200 && data.status === 'completed') {
      this.presenter.stopPollAction(bankResultAction);

      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (callbacks) {
        // If results are pass or true, means statements are good
        // NOTE: FE doesn't care about the RESULTS because we have not implemented
        // DLA or ABV, results will always be `fail`

        if (callbacks.success) {
          callbacks.success(data, response);
        }
      }.bind(this, callbacks));
    } else if (response !== 200 && (data.status !== 'processing' || data.status !== 'initiated')) {
      this.presenter.stopPollAction(bankResultAction);

      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function (callbacks) {
        if (callbacks.failure) {
          callbacks.failure(data, response);
        }
      }.bind(this, callbacks, data, response));
    }

    // Auto Timeout at 2 mins, temporary until backend fix
    if (Date.now() - this._timer.getTime() > 120000) {
      this.presenter.stopPollAction(bankResultAction);
      // go to dashboard
      this.presenter.updateModel(this._LOAN_APPS_MODEL + '[' + index + ']', null, function () {
        if (callbacks.failure) {
          callbacks.failure({
            errors: [{
              code: 408,
              msg: 'No verify bank account action found'
            }]
          }, 408);
        }
      }.bind(this, callbacks));
    }
  };

  // ******** Get Data Methods ******** //

  // Retrieves the loan application product type
  this.getLoanApplicationProduct = function () {
    var modelProperty = this.getModelPath() + '.product_type';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Retrieves the amount the users has applied for
  this.getLoanApplicationAmount = function () {
    var modelProperty = this.getModelPath() + '.amount';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Retrieves the term value in years from loan application
  this.getTermsInYears = function () {
    var modelProperty = this.getModelPath() + '.terms';

    if (this.presenter.getModelProperty(modelProperty)) {
      var terms = this.presenter.getModelProperty(modelProperty);
      var year = +parseFloat(terms / 12).toFixed(2);

      return year;
    }
    return '';
  };

  this.getTermsInMonths = function () {
    var modelProperty = this.getModelPath() + '.terms';
    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  this.getTermsInPreferredUnits = function () {
    var preferredUnit = this.presenter.getModelProperty(this.getModelPath() + '.display_terms_as');
    if (preferredUnit === 'month') {
      return this.getTermsInMonths() + ' month';
    }
    if (preferredUnit === 'year') {
      return this.getTermsInYears() + ' year';
    }
    return '';
  };

  // Retrieves the first payment date value from loan application
  this.getFirstPaymentDate = function () {
    var modelProperty = this.getModelPath() + '.first_payment_date';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Retrieves the employer name from loan application
  this.getEmployerName = function () {
    var modelProperty = this.getModelPath() + '.employment.name';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Retrieves the employer phone number from loan application
  this.getEmployerPhoneNumber = function () {
    var modelProperty = this.getModelPath() + '.employment.phone_number';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Retrieves the employer phone number extension from loan application
  this.getEmployerPhoneExt = function () {
    var modelProperty = this.getModelPath() + '.employment.extension';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Retrieves the user's original submitted first pay date
  this.getFirstPayDate = function () {
    if (this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.first_pay_date')) {
      return this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.first_pay_date');
    }
    return '';
  };

  // Retrieves the user's original submitted second pay date
  this.getSecondPayDate = function () {
    if (this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.second_pay_date')) {
      return this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.second_pay_date');
    }
    return '';
  };

  // Retrieves the users job title from loan application
  this.getJobTitle = function () {
    var modelProperty = this.getModelPath() + '.employment.job_title';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Checks whether the user choose loan protection
  this.isProtected = function () {
    var modelProperty = this.getModelPath() + '.is_protected';

    if (this.presenter.getModelProperty(modelProperty) != null) {
      return this.presenter.getModelProperty(modelProperty); // True or False boolean value
    }
  };

  // Checks whether the user is eligible for protection
  this.isProtectionEligible = function () {
    var modelProperty = this.getModelPath() + '.is_protection_eligible';

    if (this.presenter.getModelProperty(modelProperty) != null) {
      return this.presenter.getModelProperty(modelProperty); // True or False boolean value
    }
  };

  /*
    Retrieves loan application pay_frequency from submitted model else temp model
    to be used for next steps.
  */
  this.getPayFrequency = function () {
    var index = this._getApplicationArrayIndex();
    if (this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.pay_frequency')) {
      return this.presenter.getModelProperty(this._LOAN_APPS_TEMP_INCOME_MODEL + '.pay_frequency');
    }
    return this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.pay_frequency');
  };

  /*
    Retrieves loan application pay_frequency value sentenced cased from submitted model else temp model 
    to be used for next steps.
  */
  this.getPayFrequencyText = function () {
    var submittedModelProperty = this.getModelPath() + '.employment.pay_frequency';
    var paymentFrequency = '';
    var text = '';

    if (this.presenter.getModelProperty(submittedModelProperty)) {
      paymentFrequency = this.presenter.getModelProperty(submittedModelProperty);
    }

    switch (paymentFrequency) {
      case 'bi_weekly':
        text = 'Bi Weekly';
        break;
      case 'weekly':
        text = 'Weekly';
        break;
      case 'monthly':
        text = 'Monthly';
        break;
      case 'semi_monthly':
        text = 'Semi Monthly';
        break;
    }
    return text;
  };

  /*
    Retrieves loan application payment_frequency from submitted model
  */
  this.getPaymentFrequency = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.payment_frequency';
    var employmentModelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.employment.pay_frequency';
    var paymentFrequency = '';

    if (this.presenter.getModelProperty(modelProperty)) {
      paymentFrequency = this.presenter.getModelProperty(modelProperty);
    } else if (this.presenter.getModelProperty(employmentModelProperty)) {
      switch (this.presenter.getModelProperty(employmentModelProperty)) {
        case 'bi_weekly':
        case 'weekly':
          paymentFrequency = 'biweekly';
          break;
        case 'monthly':
        case 'semi_monthly':
          paymentFrequency = 'monthly';
          break;
      }
    }
    return paymentFrequency;
  };

  /*
   Retrieves loan application last_pay_of_month from the employment submitted model
  */
  this.isLastPayOfMonth = function () {
    var modelProperty = this._LOAN_APPS_TEMP_INCOME_MODEL + '.last_day_of_month';

    if (this.presenter.getModelProperty(modelProperty) !== true) {
      return false;
    }
    return true;
  };

  /*
    Retrieves loan application pay_frequency from submitted model else temp model
    to be used for next steps.
  */
  this.getBankId = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.bank_account.bank_id';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Returns Model Property Reference path to Terms
  this.getTermsReference = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.terms';

    if (this.presenter.getModelProperty(this._LOAN_APPS_MODEL + '[' + index + ']' + '.terms')) {
      return modelProperty;
    }
    return '';
  };

  /*
    Retrieves loan application status. digital_status property
     Possible status's
    1. IN_PROGRESS = ‘in_progress’
    2. OUTSTANDING_DOCS = ‘outstanding_docs’
    3. INITIAL_REVIEW = ‘initial_review’
    4. ADDITIONAL_REVIEW = ‘additional_review’
    5. ADDITIONAL_CONDITIONS = ‘additional_conditions’
    6. ENGAGE = ‘engage’
    7. AGREEMENTS_READY = ‘agreements_ready’
    8. AGREEMENTS_EXPIRED = ‘agreements_expired’
    9. AGREEMENTS_SIGNED = ‘agreements_signed’
    10. DECLINED = ‘declined’
    11. RELINK = 'relink'
     FE only
    12. `bank_service_in_progress`
     HOLD - offers class cross reference check, computed in MoneyController
    ORIGINATED = ‘originated’ - handled before getting here
    EXPIRED = ‘expired’ - applications with withdrawn and expired will not be returned .
     https: //www.lucidchart.com/documents/edit/bb0902e9-56b9-4b49-86d2-5f1a2cb601ed/1
  */

  this.getStatus = function () {
    var modelProperty = this.getModelPath() + '.digital_status';

    if (this.presenter.getModelProperty(modelProperty)) {
      // Check if application is in bank service in progress
      if (this.isBankServiceInProgress()) {
        return 'bank_service_in_progress';
      }
      return this.presenter.getModelProperty(modelProperty);
    }
    return false;
  };

  this.getApplicationLender = function () {
    var modelProperty = this.getModelPath() + '.lender_id';
    return this.presenter.getModelProperty(modelProperty) || false;
  };

  /*
    Check if bank statements are retrieved for the linked loan application
     IE. loan application bank account `bank_verification_result` rellink
    returns a `complete` and NOT `processing` status
     Conditions:
    1) loan application digital status is `in_progress` &&
    2) `bank_verification_result` rellink exists, this exists only when
    FE performAction on `bank_verification`
     returns true if it's still in process of retrieving
  */
  this.isBankServiceInProgress = function () {
    var digitalStatusProperty = this.getModelPath() + '.digital_status';
    var bankResultAction = this.getModelPath() + '.bank_verification_result';

    if (this.presenter.getModelProperty(digitalStatusProperty) === 'in_progress' && this.presenter.hasAction(bankResultAction)) {
      return true;
    }
    return false;
  };

  // Returns Model Property Reference path to Apr
  this.getAprReference = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.apr';

    if (this.presenter.getModelProperty(modelProperty)) {
      return modelProperty;
    }
    return '';
  };

  // Returns Model Property Reference path to protection
  this.getProtectionReference = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.is_protected';

    // sometimes it's false
    return modelProperty;
  };

  // Returns Model Property Reference path to bank_id
  this.getBankIdReference = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.bank_account.bank_id';
    // sometimes it's false
    return modelProperty;
  };

  // Checks for user hard credit check consent
  // checks for timestamp in the hard_credit_check_consented_at property
  this.hasHardConsent = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.hard_credit_check_consented_at';

    if (this.presenter.getModelProperty(modelProperty)) {
      return true;
    }
    return false;
  };

  // Returns the time the user submitted consent
  this.getHardConsentTime = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.hard_credit_check_consented_at';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Returns Model Property Reference path to bank_id
  this.getStatusReference = function () {
    var modelProperty = this.getModelPath() + '.digital_status';

    return modelProperty;
  };

  // Returns Model Property Reference path to relink_reason
  this.getRelinkReference = function () {
    var modelProperty = this.getModelPath() + '.relink_reason';

    return modelProperty;
  };

  // Returns ABS Status property value
  this.getAbsStatus = function () {
    var modelProperty = this.getModelPath() + '.bank_account.abs_status';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Returns Relink Reason property value
  this.getRelinkReason = function () {
    var modelProperty = this.getModelPath() + '.relink_reason';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return '';
  };

  // Returns the step the user should be on
  this.getCurrentStep = function () {
    var steps = [{
      url: '/member/dashboard/loans/application/phone-verification',
      completed: 'hasSubmittedPhoneVerification'
    }, {
      url: '/member/dashboard/loans/application/employment',
      completed: 'hasSubmittedEmployment'
    }, {
      url: '/member/dashboard/loans/application/income',
      completed: 'hasSubmittedIncome'
    }, {
      url: '/member/dashboard/loans/application/loan-customization',
      completed: 'hasSubmittedLoanAmount'
    }, {
      url: '/member/dashboard/loans/application/review',
      completed: 'hasSubmittedReview'
    }];

    var completed = true;
    for (var i = 0; i < steps.length; i++) {
      completed = this[steps[i].completed].bind(this).call();
      // return uncompleted steps url or review
      // should not need to check start step as application is already in progress
      if (!completed) {
        return steps[i].url;
      }
    }
    // Users are directed to intermediary bank intro view
    if (completed) return '/member/dashboard/loans/application/bank-introduction';
  };

  // Returns last user saved point (different from current step!)
  this.getLastSavedPoint = function () {
    var steps = [{
      completed: this.hasLoanApplicationIndex(),
      name: 'Lets Begin'
    }, {
      completed: this.hasSubmittedPhoneVerification(),
      name: 'Phone Number'
    }, {
      completed: this.hasSubmittedEmployment(),
      name: 'Employment'
    }, {
      completed: this.hasSubmittedIncome(),
      name: 'Payment Frequency'
    }, {
      completed: this.hasSubmittedLoanAmount(),
      name: 'Loan Options'
    }, {
      completed: this.hasBankInProgress(),
      name: 'Review'
    }];

    var completed = true;
    for (var i = 0; i < steps.length; i++) {
      completed = steps[i].completed;
      // should not need to check start step as application is already in progress
      // Return steps - 1
      if (!completed && i !== 0) {
        return steps[i - 1].name;
      }
    }

    if (completed) {
      // we have check logic here for backwards compatibility
      // Originally, banking was before review step
      // Remove end of year.
      if (this.hasHardConsent() && !this.hasSubmittedBankAccount()) {
        return 'Review Submitted';
      }
      if (this.getStatus() === 'bank_service_in_progress') {
        // Members during ABS retrieval
        return 'Bank Service';
      }
      return 'Bank';
    }
  };

  // In the case where a user selects Jan 29th for there first (monthly) or second (semi monthly) pay date,
  // BE returns Feb 28th because 29th does not exist in Feb.
  // In this scenario, FE should make the subsequent estimated payment dates back to 29th.
  this.getSubmittedPaymentDate = function () {
    var firstPaymentDate = this.getFirstPaymentDate();
    var firstPayDate = this.getFirstPayDate() ? this.getFirstPayDate() : false; // Get the month
    var secondPayDate = this.getSecondPayDate() ? this.getSecondPayDate() : false; // Get the month
    var parsedDate = '';

    var year = firstPaymentDate.split('-')[0];
    var month = firstPaymentDate.split('-')[1];
    var day = firstPaymentDate.split('-')[2];

    if (moment([year, month, day]).format('DD') === moment([year, month, day]).format('DD')) {
      parsedDate = firstPayDate;
    } else {
      parsedDate = secondPayDate;
    }

    if (!parsedDate) parsedDate = firstPayDate || firstPaymentDate; // If no date exists, default to firstPayDate

    return parsedDate;
  };

  /*
   Retrieves loan application id
  */
  this.getLoanApplicationId = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.loan_application_id';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return false;
  };

  /*
    Retrieves approved_product_id
  */
  this.getLoanApplicationOfferId = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.approved_product_id';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return null;
  };

  /* 
    Determines if Loan Application has Abv_results_id value
  */
  this.hasAbvResults = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this._LOAN_APPS_MODEL + '[' + index + ']' + '.abv_result_id';

    if (this.presenter.getModelProperty(modelProperty)) {
      return this.presenter.getModelProperty(modelProperty);
    }
    return false;
  };

  // ******** Step Checks ******** //

  this.hasLoanApplicationIndex = function () {
    // Index is 0
    if (this._getApplicationArrayIndex() > -1) {
      return true;
    }
    return false;
  };

  this.hasSubmittedPhoneVerification = function () {
    return !!this.presenter.getModelProperty('account.phone_number');
  };

  // Checks to see if ALL required employment fields are there
  // * Member with a previous FS loan may only have partial information.
  // Required fields on the employment steps are: employment.phone_number, employment.job_title, employment.name
  this.hasSubmittedEmployment = function () {
    var modelProperty = this.getModelPath() + '.employment';

    return !!this.presenter.getModelProperty(modelProperty + '.name') && !!this.presenter.getModelProperty(modelProperty + '.phone_number') && !!this.presenter.getModelProperty(modelProperty + '.job_title');
  };

  // Checks to see if bank account obj is empty
  this.hasSubmittedBankAccount = function () {
    var index = this._getApplicationArrayIndex();
    var modelProperty = this.presenter.models.money.applications.loan_applications[index].bank_account;
    if (modelProperty instanceof APIModel) {
      return true;
    }
    return false;
  };

  // Needs Amount, IS protected value, BOOLEAN
  this.hasSubmittedLoanAmount = function () {
    var modelProperty = this.getModelPath() + '.is_protected';

    if (this.presenter.getModelProperty(modelProperty) !== null && this.getLoanApplicationAmount()) {
      return true;
    }
    return false;
  };

  // Checks if user submitted
  // PayFrequency, Amount and First Payment date
  // Can have either first payment date or last day of month
  this.hasSubmittedIncome = function () {
    var modelProperty = this.getModelPath() + '.last_day_of_month';

    if (this.getPayFrequency() && (this.getFirstPaymentDate() || this.presenter.getModelProperty(modelProperty))) {
      return true;
    }
    return false;
  };

  // Checks if user has completed hard consent
  this.hasSubmittedReview = function () {
    if (this.hasHardConsent()) {
      return true;
    }
    return false;
  };

  /*
    In Progress - Bank, Analytics Requirements
    for these two cases:
      A) The user submitted their bank, but the Loan Application submission failed
      B) A user is coming from the previous version of the Loan Application flow,
      and they had submitted their bank but not the review screen.
       Bank Submitted | Consent Submitted | What is the Loan Application Status ?
      No | No | Loan Options
      No | Yes | Review Submitted
      Yes | No | Bank
      Yes | Yes | Bank
  */
  this.hasBankInProgress = function () {
    if (this.hasSubmittedReview() || this.hasSubmittedBankAccount()) {
      return true;
    }
    return false;
  };

  /** Class Helpers */

  // Set the submit button even further
  this._setDisableLoadState = function (formElement) {
    if (formElement) {
      $(formElement).find('[data-mogo-ui-type="submit"]').each(function () {
        $(this).mogo().setDisabledLoadState();
      });
    }
  };

  // Remove the submit button even further
  this._removeDisableLoadState = function (formElement) {
    if (formElement) {
      $(formElement).find('[data-mogo-ui-type="submit"]').each(function () {
        $(this).mogo().removeDisabledLoadState();
      });
    }
  };

  this._createTeardownFunction = function (action, callbackId) {
    return function (a, c) {
      this.removeCallbackFromAction(a, c);
    }.bind(this.presenter, action, callbackId);
  };

  this.constructor = function () {
    this._index = this._getApplicationArrayIndex();

    // Set Temp Models for reference
    this.setTempIncomeModel();
  };

  this.constructor();
}